// Import Components
import TittleLink from 'components/common/TittleLink';
import CopyToClipboard from 'components/common/CopyToClipboard';
import AdminProviderPartnersInfo from './AdminProviderPartnersInfo';
// Import Constants
import { l, Position } from 'constants/common';
import { REQUEST_TYPE_OPTIONS } from '../SMSProviderCECPage/constants';

export const DataTableColumnsConfigs = (t) => {
    return {
        columns: [
            {
                text: l.ProviderId,
                dataKey: 'SmsProviderId',
                sortable: true,
                colRenderer: (id: string) => (
                    <CopyToClipboard withWrapper={true}>
                        <TittleLink isClickable={false} name={id} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.ApiKey,
                dataKey: 'ApiKey',
                sortable: true,
                colRenderer: (apiKey: string) => (
                    <CopyToClipboard position={Position.Left} withWrapper={true}>
                        <TittleLink isClickable={false} name={apiKey || t(l.NA)} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.Name,
                dataKey: 'Name',
                sortable: true,
                colRenderer: (name: string) => (
                    <CopyToClipboard position={Position.Left} withWrapper={true}>
                        <TittleLink isClickable={false} name={name} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.FromAddress,
                dataKey: 'FromAddress',
                sortable: true,
                colRenderer: (address: string) => (
                    <CopyToClipboard position={Position.Left} withWrapper={true}>
                        <TittleLink isClickable={false} name={address} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.RequestType,
                dataKey: 'RequestType',
                sortable: true,
                colRenderer: (requestType: number) => (
                    <TittleLink
                        isClickable={false}
                        name={REQUEST_TYPE_OPTIONS.find(({ value }) => requestType === value)?.label || t(l.NA)}
                    />
                ),
            },
            {
                text: l.UserName,
                dataKey: 'UserName',
                sortable: true,
                colRenderer: (userName: string) => <TittleLink isClickable={false} name={userName} />,
            },
            {
                text: l.Partner,
                dataKey: 'Partner',
                sortable: false,
                colRenderer: (partner) => <AdminProviderPartnersInfo partners={partner ? [partner] : []} />,
            },
            {
                text: l.Description,
                dataKey: 'Description',
                sortable: true,
                colRenderer: (description) => <TittleLink isClickable={false} name={description || l.NA} />,
            },
        ],
    };
};

export const getTableRows = (providerList) => {
    return providerList.map(({ SmsProviderId, ...restData }) => {
        return {
            hasHover: true,
            dragDisable: true,
            nestedData: [],
            data: {
                rowKey: SmsProviderId,
                isRowOpend: false,
                SmsProviderId,
                ...restData,
            },
        };
    });
};
